import styled from "styled-components";

export const PageWrapper = styled.div`
  display: flex;
  flex-direction: column;
  height: 100vh;
  position: relative;
  background: #FFFFFF;
  border-radius: 20px;
`; 